import { useEffect } from "react";
import { useAppDispatch } from "../../store/config";
import { DietLayout } from "./style";
import { Outlet } from "react-router-dom";
import { resetRecipes } from "../../store/features/recipes/recipes-slice";

export const Diet = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetRecipes());
    };
  }, []);

  return (
    <DietLayout>
      <Outlet />
    </DietLayout>
  );
};
